import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from 'react';
import { CloseOutlineIcon } from "../Icons";
import { ClassNames } from '@emotion/react';
import { pillStyles as classes } from './styles';
/**
 * An interactive component used to organize and categorize
 */
export const Pill = ({ variant = 'primaryFilled', size = 'small', children, icon, onRemove, renderLink, onClick, disabled = false, isSelected = false, className, ref, }) => {
    const isClickable = !!onClick;
    const Root = isClickable ? 'button' : 'div';
    return (_jsxs(Root
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    , { 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref: ref, css: classes.root(isClickable, size, variant, !!renderLink), disabled: isClickable ? disabled : undefined, "data-disabled": disabled || undefined, "data-selected": isSelected || undefined, className: className, onClick: onClick, children: [icon ? _jsx("span", { css: classes.iconWrapper, children: icon }) : null, renderLink && !isClickable ? (_jsx(ClassNames, { children: ({ css }) => React.cloneElement(renderLink, {
                    ...renderLink.props,
                    className: css([classes.label, classes.linkLabel]),
                    tabIndex: disabled ? -1 : 0,
                    ['aria-disabled']: disabled || undefined,
                    children: children ?? renderLink.props.children,
                }) })) : (_jsx("span", { css: classes.label, children: children })), onRemove && !isClickable ? (_jsx("button", { disabled: disabled, "aria-label": children ? `Remove ${children}` : 'Remove', css: [classes.iconWrapper, classes.removeButton], onClick: onRemove, children: _jsx(CloseOutlineIcon, {}) })) : null] }));
};
